// extracted by mini-css-extract-plugin
export default {"ScreenSizePage":"ScreenSizePage_ScreenSizePage__JGnY0","screenSizeCard":"ScreenSizePage_screenSizeCard__-h7uY"};